<div ngModelGroup="comboMotivoDesligamento-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboMotivoDesligamento
                       nome="motivoDesligamento-{{data}}"
                       [itens]="dados"
                       itemDescricao="motivoDesligamento"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Motivo Desligamento"
                       label="Motivo Desligamento"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
